import React from 'react';
import PropTypes from 'prop-types';

function LeftNameSection({ wedding }) {
  return (
    <div className="name-section-left">
      <h2 className="partner-1-name">
        {wedding.owner_first_name && <span className="first-name"><span className="first-initial">{wedding.owner_first_name[0]}</span><span className="full-first-name">{wedding.owner_first_name.slice(1, wedding.owner_first_name.length)}</span></span>}
        {wedding.owner_last_name && <span className="last-name"><span className="last-initial"> {wedding.owner_last_name[0]}</span><span className="full-last-name">{wedding.owner_last_name.slice(1, wedding.owner_last_name.length)}</span></span>}
      </h2>
    </div>
  );
}

LeftNameSection.propTypes = {
  wedding: PropTypes.shape({}).isRequired,
};

export default LeftNameSection;




// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/Home/LeftNameSection.jsx